import { Link } from 'react-router-dom';
import type { AnimeItem } from '@/mocks/anime';

interface AnimeCardProps {
  anime: AnimeItem;
}

export default function AnimeCard({ anime }: AnimeCardProps) {
  return (
    <Link
      to={`/anime/${anime.id}`}
      className="group block rounded-lg overflow-hidden bg-white border border-background-200/70 hover:border-primary-200 transition-all duration-300"
    >
      <div className="relative aspect-[3/4] overflow-hidden">
        <img
          src={anime.coverImage}
          alt={`${anime.title} - 羞羞动漫推荐`}
          title={`${anime.title} | 羞羞动漫在线观看`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute top-2 left-2">
          <span className="px-2 py-0.5 bg-primary-500 text-white text-xs rounded-md whitespace-nowrap">
            {anime.rating}
          </span>
        </div>
        <div className="absolute top-2 right-2">
          <span className="px-2 py-0.5 bg-black/60 text-white text-xs rounded-md whitespace-nowrap">
            {anime.episodes}
          </span>
        </div>
        {anime.status === '连载中' && (
          <div className="absolute bottom-2 left-2">
            <span className="px-2 py-0.5 bg-accent-500 text-white text-xs rounded-md whitespace-nowrap">
              连载中
            </span>
          </div>
        )}
      </div>
      <div className="p-3">
        <h3 className="text-sm font-medium text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-1 mb-1">
          {anime.title}
        </h3>
        <div className="flex items-center justify-between">
          <span className="text-xs text-foreground-500 whitespace-nowrap">{anime.category}</span>
          <span className="text-xs text-foreground-400 whitespace-nowrap">{anime.views.toLocaleString()} 次观看</span>
        </div>
      </div>
    </Link>
  );
}